"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HStack = exports.VStack = exports.Stack = void 0;
var React = require("react");
var Theme_1 = require("../../Theme");
var Stack_styles_1 = require("./Stack.styles");
var Stack = function (_a) {
    var children = _a.children, Height = _a.Height, Gap = _a.Gap, _b = _a.Align, Align = _b === void 0 ? "center" : _b, _c = _a.Flow, Flow = _c === void 0 ? "row" : _c, Pad = _a.Pad, ContentSizing = _a.ContentSizing, JustifyContent = _a.JustifyContent, AutoRows = _a.AutoRows, _d = _a.AutoColumns, AutoColumns = _d === void 0 ? "1fr" : _d;
    var buildSize = function (size) {
        switch (size) {
            default:
            case "none":
                return "0";
            case "xxSmall":
                return Theme_1.PixelUnit(0.5);
            case "xSmall":
                return Theme_1.PixelUnit(1);
            case "small":
                return Theme_1.PixelUnit(2);
            case "medium":
                return Theme_1.PixelUnit(3);
            case "large":
                return Theme_1.PixelUnit(5);
            case "xLarge":
                return Theme_1.PixelUnit(7);
            case "xxLarge":
                return Theme_1.PixelUnit(9);
        }
    };
    var buildType = function () {
        if (Flow === "column" && ContentSizing) {
            return "grid-template-columns: " + ContentSizing;
        }
        else if (Flow === "row" && ContentSizing) {
            return "grid-template-rows: " + ContentSizing;
        }
    };
    return (React.createElement(Stack_styles_1.StackContainerDiv, { Align: Align, AutoColumns: AutoColumns, AutoRows: AutoRows, Pad: buildSize(Pad), Gap: buildSize(Gap), Flow: Flow, ContentSizing: buildType(), JustifyContent: JustifyContent, Height: Height }, children));
};
exports.Stack = Stack;
var VStack = function (props) { return React.createElement(exports.Stack, __assign({}, props, { Flow: "row" })); };
exports.VStack = VStack;
var HStack = function (props) { return React.createElement(exports.Stack, __assign({}, props, { Flow: "column" })); };
exports.HStack = HStack;
